import "./Employees.scss";

import { Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

import AppButton from "../../commons/buttons/AppButton";
import AppLoading from "../../commons/AppLoading";
import CompanyAPI from "../company/CompanyAPI";
import ConfirmModal from "../../commons/modal/ConfirmModal";
import EmployeeCard from "./components/EmployeeCard";
import EmployeeModal from "./components/EmployeeModal";
import FloatingButton from "../../commons/buttons/FloatingButton";
import FloatingVideoButton from "../../commons/buttons/FloatingVideoButton";
import HallAppConst from "../../commons/util/HallAppConst";
import HallAppToast from "../../commons/HallAppToast";
import MenuTitle from "../../commons/menu/MenuTitle";
import PullToRefresh from "react-simple-pull-to-refresh";
import { faAdd } from "@fortawesome/free-solid-svg-icons";

function Employess() {
  const [isLoading, setIsLoading] = useState(true);
  const [showModalAddEmpoyee, setShowModalAddEmpoyee] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [isLoadingResendEmail, setIsLoadingResendEmail] = useState(false);
  const [employee, setEmployee] = useState([]);

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false);

  const companyAPI = new CompanyAPI();

  useEffect(() => {
    getAllEmployee();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllEmployee = async () => {
    setIsLoading(true);
    try {
      const response = await companyAPI.getAllEmployee(companyAPI.getCompanyManagment().id);
      setEmployees(response.data);
      setIsLoading(false);
    } catch (_) {
      setEmployees([]);
      setIsLoading(false);
    }
  };

  async function resendEmail(employee) {
    setIsLoadingResendEmail(true);
    try {
      await companyAPI.resendEmailEmployee(companyAPI.getCompanyManagment().id, employee);
      setIsLoadingResendEmail(false);
      HallAppToast.success();
    } catch (_) {
      HallAppToast.error();
      setIsLoadingResendEmail(false);
    }
  }

  const deleteEmployee = async () => {
    setIsLoadingModalDelete(true);
    await companyAPI
      .deleteEmployee(companyAPI.getCompanyManagment().id, employee.id)
      .then(async (_) => {
        HallAppToast.success();
        setShowModalDelete(false);
        await getAllEmployee();
      })
      .catch((_) => {
        HallAppToast.error(HallAppConst.GENERIC_ERROR);
      })
      .finally((_) => {
        setIsLoadingModalDelete(false);
      });
  };

  return (
    <>
      <PullToRefresh onRefresh={getAllEmployee}>
        {/* ✅ container só no desktop */}
        <div className="container-md employees-page">
          <Row style={{ margin: 0 }}>
            {isLoading ? (
              <div style={{ alignItems: "center", textAlign: "center", float: "center" }}>
                <Col xs={12}>
                  <AppLoading />
                </Col>
              </div>
            ) : (
              <>
                <MenuTitle title="Funcionários" showArrowInfo={false} />

                {employees.map((data) => (
                  <Col xs={12} sm={12} md={6} lg={4} key={data.id} style={{ marginBottom: "10px" }}>
                    <div className="employee-cardWrap">
                      <EmployeeCard
                        isLoadingResendEmail={isLoadingResendEmail}
                        employee={data}
                        resendEmail={resendEmail}
                      />

                      {/* ✅ Ações (igual padrão Categorias/Serviços) */}
                      <div className="employee-miniCard__actions">
                        <AppButton
                          type="button"
                          width="100%"
                          name="Editar"
                          variant="secondary"
                          className="mb-0"
                          onClick={() => {
                            setEmployee(data);
                            setShowModalAddEmpoyee(true);
                          }}
                        />

                        <AppButton
                          type="button"
                          width="100%"
                          name="Excluir"
                          variant="danger"
                          className="mb-0"
                          onClick={() => {
                            setEmployee(data);
                            setShowModalDelete(true);
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                ))}
              </>
            )}
          </Row>
        </div>
      </PullToRefresh>

      <FloatingButton
        icon={faAdd}
        onClick={() => {
          setEmployee(null);
          setShowModalAddEmpoyee(true);
        }}
      />

      {showModalAddEmpoyee && (
        <EmployeeModal
          updateListEmployees={getAllEmployee}
          employee={employee}
          show={showModalAddEmpoyee}
          closeModal={() => {
            setEmployee({});
            setShowModalAddEmpoyee(false);
          }}
        />
      )}

      <FloatingVideoButton youtubeUrl={"https://www.youtube.com/embed/q6flc768-rQ"} />

      <ConfirmModal
        show={showModalDelete}
        title="Excluir"
        isLoading={isLoadingModalDelete}
        confirm={() => deleteEmployee()}
        closeModal={() => setShowModalDelete(false)}
      >
        Deseja remover o funcionario <span style={{ fontWeight: "bold" }}>{employee?.name}</span>?
      </ConfirmModal>

      <div style={{ height: "calc(50px + 72px)" }}></div>
    </>
  );
}

export default Employess;
